const ITERABLE_USER_ID_STORAGE_KEY = 'iterable_user_id';

function getIterableUtmUidFromQuery() {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get('utm_uid');
}

function getIterableUserId() {
    try {
        return window.localStorage.getItem(ITERABLE_USER_ID_STORAGE_KEY);
    } catch (e) {
        return null;
    }
}

export function captureIterableSearchIdentity() {
    const utmUid = getIterableUtmUidFromQuery();
    if (!utmUid) {
        return;
    }

    try {
        window.localStorage.setItem(ITERABLE_USER_ID_STORAGE_KEY, utmUid);
    } catch (e) {
    }
}

export function getIterableSearchIdentityParams() {
    const iterableUserId = getIterableUserId();
    if (iterableUserId) {
        return { iterable_user_id: iterableUserId };
    }

    return {};
}

export function withIterableSearchIdentity(params) {
    return {
        ...params,
        ...getIterableSearchIdentityParams(),
    };
}

function isSearchRequest(request) {
    const method = (request.method || '').toUpperCase();
    const url = new URL(request.url || '', window.location.origin);

    return ['POST', 'PUT'].indexOf(method) !== -1
        && url.pathname.indexOf('search') !== -1;
}

export function registerIterableSearchIdentityVueResourceInterceptor() {
    if (!window.Vue || !Vue.http) {
        return;
    }

    Vue.http.interceptors.push((request, next) => {
        if (isSearchRequest(request)) {
            request.body = withIterableSearchIdentity(request.body || {});
        }

        next();
    });
}
